

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import ApprovalToEmail from "@/components/ApprovalToEmail.vue";
import store from "@/store";
@Component({
  components: { ApprovalToEmail },
})
export default class ApprovePage extends Vue {
  ishurFile: any = null;
  displaySendByMailDialog: boolean = false;
  email: string = "";
  constructor() {
    super();
  }
  created() {
    if (this.$route.params) {
      this.email = this.$route.params.email;
    }
  }

  onShowResidentApproval(isDownload?) {
    if (this.ishurFile) {
      if (!isDownload) this.displayApprovment();
      else this.fileDownload();
    } else {
      this.appEnv.isBusy = true;
      apiService
        .getFile(
          "Approvment/GetAuthorizedIshurToshav",
          this.appEnv.requestParams.requestId
        )
        .then((res) => {
          if (res) {
            if (res.size > 0) {
              this.ishurFile = res;
              if (!isDownload) this.displayApprovment();
              else this.fileDownload();
            } else {
              this.onShowFileError();
            }
          } else {
            this.onShowFileError();
          }
          this.appEnv.isBusy = false;
        })
        .catch((err) => {
          this.onShowFileError();
          this.appEnv.isBusy = false;
        });
    }
  }

  onSendRequestViaEmail() {}

  displayApprovment() {
    var url = URL.createObjectURL(this.ishurFile);
    window.open(url, "_blank");
  }

  fileDownload() {
    const url = window.URL.createObjectURL(new Blob([this.ishurFile]));
    const link = document.createElement("a");
    link.href = url;
    var fileName = "אישור תושב לשנת" + " " + this.year + ".pdf";
    link.setAttribute("download", fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }

  onShowFileError() {
    this.appEnv.showErrorDialog([
      { message: "שגיאה כללית בהצגת טופס אישור תושב" },
    ]);
  }

  get requestNo() {
    return this.appEnv.requestParams.requestNo;
  }

  get year() {
    return this.appEnv.requestParams.year;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
